import React, { useState } from "react";
import Button from "../UI/Buttons/Button";
import useApi from "../../Hooks/useApi";
import TextField from "../UI/Inputs/TextField";
import showToast from "../../Helpers/toast";
import { addSection } from "../../Utils/questionnaireUtils";

const SectionForm = ({
  questionnaireId,
  sectionList,
  setSectionList,
  sideFunctions,
  moduleType="kii"
}) => {
  const { request } = useApi();
  const [sectionName, setSectionName] = useState();

  const handleAddNewSection = async (event) => {
    event.preventDefault();

    if (questionnaireId && sectionName) {
      try {
        const response = await addSection(request, {
          name: sectionName,
          status: "ACTIVE",
          sectionOrder: 0,
          questionnaireId: questionnaireId,
          required: true,
        },moduleType);

        setSectionList(sectionList ? [...sectionList, response] : [response]);
        sideFunctions(response.sectionId);

        showToast({ message: "New section added" });
      } catch (error) {
        console.log(error);
        showToast({
          message: error?.response?.data?.message || "Error Occurred",
          type: "error",
        });
      }
    } else {
    }
  };

  return (
    <div className="relative border-2 my-4 p-5 space-y-2">
      <p className="">Add New Section to Questionnaire</p>
      {/* CLose Button */}
     <form onSubmit={handleAddNewSection} className=" space-y-2">
        <TextField
        style={{width:"1800px"}}
          name={"sectionName"}
          placeholder={"Section Title"}
          value={sectionName}
          onValueChange={(_, val) => {
            setSectionName(val);
          }}
          required={true}
        />

        <Button
          type={"small_bordered"}
          label={"ADD"}
          backgroundColor={"#2F4B7C"}
          textColor={"white"}
          style={{
            width: "100px",
            alignSelf: "center",
          }}
        />
      </form>
      {/* )} */}
    </div>
  );
};

export default SectionForm;

// {
//   sectionId: 2,
//   name: 'Section 01',
//   status: 'ACTIVE',
//   sectionOrder: 0,
//   questionnaireId: 16,
//   required: true
// }
